import {TaskRepetition} from '@hconnect/common/types'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {Grid, Typography} from '@mui/material'
import {Moment} from 'moment'

import {ProcessWorkOrderDueDatesPreviewLabel} from '../ProcessWorkOrderDueDatesPreviewLabel'

type Props = {
  settings: TaskRepetition
  plantId: string
  defaultStartDate?: Moment
  isRecurring: boolean
}

export const TaskRepetitionDueDatesPreview = ({
  settings,
  plantId,
  defaultStartDate,
  isRecurring
}: Props) => {
  const timezone = useUpmPlantTimezone(plantId)
  if (!defaultStartDate || !isRecurring) return null
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="caption">
          <ProcessWorkOrderDueDatesPreviewLabel
            settings={settings}
            defaultStartDate={defaultStartDate}
            omitFirstOccurrence
            plantId={plantId}
            timezone={timezone}
          />
        </Typography>
      </Grid>
    </>
  )
}
